<template>

  <div class="card p-3">
    <div class="card-header">

      <div
        class="start-50 translate-middle icon icon-lg text-light d-flex align-items-center justify-content-center bg-success shadow-success text-center border-radius-xl mt-n4 position-absolute"
        style="top: 30px">
        <i class="bi bi-person-check-fill fs-3"></i>
      </div>
      <div class="text-center pt-1">
        <p class="fw-bold text-dark mt-3 mb-1 text-capitalize">
          ورود به سامانه
        </p>
      </div>
    </div>
    <hr class="dark horizontal my-0" />
    <div class="phone-box text-center mt-3">
      <p class="mb-1">شماره همراه خود را وارد کنید</p>
      <input inputmode="numeric" class="form-control border border-1 text-center w-75 mx-auto" v-model.trim="phoneInput"
        @focusout="handlePhoneNumberVerification" @keyup.enter="setPhoneNumberToStore" @input="validateInput" :class="{
          'border-danger shake-ph':
            phoneNumberStore.error === 1 ||
            phoneNumberStore.error === 2 ||
            phoneNumberStore.error === 3,
          'border-success': phoneNumberStore.error === 0,
        }" type="text" maxlength="11" />
      <button @click="setPhoneNumberToStore" class="btn bg-success text-light fw-bold w-75 mt-2">
        دریافت کد
      </button>
    </div>

    <hr class="dark horizontal my-0" />
    <div class="card-footer p-3">
      <p class="mb-0 text-center fs-7">سامانه شرکت های حمل و نقل نفتی</p>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useLoginStore } from "@/store/loginStore.js";
import crypto from "@/store/crypto";

export default {

  name: "PhoneLogin",

  setup() {
    const phoneInput = ref(crypto.getData('userPhone'));
    const phoneNumberStore = useLoginStore();


    function setPhoneNumberToStore() {
      phoneNumberStore.sendPhoneNumber(phoneInput.value);
    }

    function handlePhoneNumberVerification() {
      phoneNumberStore.phoneNumberVerification(phoneInput.value);
    }


    function validateInput() {
      // تبدیل اعداد فارسی به انگلیسی
      const persianToEnglishNumbers = {
        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
      };

      // تبدیل ورودی به اعداد انگلیسی
      let inputValue = phoneInput.value.replace(/[۰-۹]/g, (match) => persianToEnglishNumbers[match]);

      // فقط مجاز به وارد کردن اعداد انگلیسی
      inputValue = inputValue.replace(/[^0-9]/g, "");

      // بروزرسانی مقدار ورودی
      phoneInput.value = inputValue;
    }

    return {
      phoneInput,
      setPhoneNumberToStore,
      handlePhoneNumberVerification,
      phoneNumberStore,
      validateInput,
    };
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0;
  /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield;
  /* Firefox */
}
</style>
